import { ERROR_PAGE_CONFIG } from '../../constants';
import { useError } from '../../contexts/useError';
import type { ErrorPageCode, ErrorPageConfig } from '../../types';

import { ErrorWidget } from './components/ErrorWidget';

import './ErrorPage.scss';

interface ErrorPageProps {
  statusCode?: number;
}

export const ErrorPage = ({ statusCode }: ErrorPageProps) => {
  const { error } = useError();

  const currentStatusCode = statusCode ?? error?.statusCode;

  // get the error message or fallback to default
  const message: ErrorPageConfig =
    ERROR_PAGE_CONFIG[currentStatusCode as ErrorPageCode] ??
    ERROR_PAGE_CONFIG.default;

  const { buttonLink, buttonText, description, title } = message;

  return (
    <div className="error-page full-page-container">
      <ErrorWidget
        buttonLink={buttonLink}
        buttonText={buttonText}
        description={description}
        title={title}
      />
    </div>
  );
};
